export function stripHtml(html) {
  if (typeof html !== "string") return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent?.trim() ?? "";
}
